import { connect, ConnectedProps } from "react-redux";

import {
  getSelectedAccountReferenceId,
  getRewardsAccounts,
} from "../../reducer";
import {
  fetchRewardsAccounts,
  setSelectedAccountReferenceId,
} from "../../actions/actions";
import { IStoreState } from "../../../../reducers/types";
import { RewardsAccountSelection } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  selectedAccountReferenceId: getSelectedAccountReferenceId(state),
  rewardsAccounts: getRewardsAccounts(state),
});

const mapDispatchToProps = {
  fetchRewardsAccounts,
  setSelectedAccountReferenceId,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type RewardsAccountSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedRewardsAccountSelection = connector(
  RewardsAccountSelection
);
